export type SpotIllustrationProps = {
	src: string;
	alt?: string;
	height?: string;
};

export const SPOT_ILLUSTRATION_MAX_HEIGHT = '168px';
